import { FamilyAnswerStatsDto } from '@families-link/shared';
import { useReactTable, getCoreRowModel } from '@tanstack/react-table';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { CoreTable, CoreTableEmptyBody } from '../../../_core/components/_ui/core-table';
import { TableListQueryResponse } from '../../../_core/interfaces/table-list-query.interface';
import { useFamiliesResponsesTableColumns } from '../../hooks/table-columns/families-responses-columns.hook';

export interface FamilyAnswerTableHandlers {
	onView(familyAnswer: FamilyAnswerStatsDto): void;
}
type FamiliesResponsesTableProps = TableListQueryResponse<FamilyAnswerStatsDto> & FamilyAnswerTableHandlers;

export const FamiliesResponsesTable: FC<FamiliesResponsesTableProps> = (props) => {
	const { data, sorting, onSortingChange, loading, hasMore, fetchMore, scrollRef, onView } = props;

	const [t] = useTranslation();

	const columns = useFamiliesResponsesTableColumns({
		onView,
	});

	const table = useReactTable<FamilyAnswerStatsDto>({
		data,
		columns,
		state: {
			sorting,
		},
		onSortingChange,
		getCoreRowModel: getCoreRowModel(),
	});

	return (
		<CoreTable
			px={0}
			ref={scrollRef}
			loading={loading}
			hasMore={hasMore}
			threshold={200}
			emptyListComponent={
				<CoreTableEmptyBody label={t('profile.sessions.table.empty-title')} description={t('surveys.no-answers')} />
			}
			fetchMore={fetchMore}
			rowModel={table.getRowModel()}
			headerGroups={table.getHeaderGroups()}
		/>
	);
};
